<div class="widget" data-testid="wcg-create-entity-root">
    @if (visibleTabs().length > 1) {
        <nav class="tabs" role="tablist" aria-label="Entity type" [hidden]="wizard.view() !== 'form'">
            @for (tab of visibleTabs(); track tab) {
                <button
                    type="button"
                    class="tabs__tab"
                    [class.tabs__tab--active]="wizard.activeTab() === tab"
                    role="tab"
                    [attr.aria-selected]="wizard.activeTab() === tab"
                    (click)="selectTab(tab)"
                    [attr.data-testid]="'wcg-create-entity-tab-' + tab"
                >
                    {{ tabLabels[tab] }}
                </button>
            }
        </nav>
    }

    @if (visibleTabs().includes('organization')) {
        <wcg-organization-form [hidden]="wizard.view() !== 'form' || wizard.activeTab() !== 'organization'" />
    }

    @if (visibleTabs().includes('facility')) {
        <wcg-facility-form [hidden]="wizard.view() !== 'form' || wizard.activeTab() !== 'facility'" />
    }

    @if (visibleTabs().includes('study')) {
        <wcg-study-form [hidden]="wizard.view() !== 'form' || wizard.activeTab() !== 'study'" />
    }

    @if (visibleTabs().includes('investigator')) {
        <wcg-investigator-panel [hidden]="wizard.view() !== 'form' || wizard.activeTab() !== 'investigator'" />
    }
    @if (wizard.view() === 'form') {
        @if (wizard.errorMessage()) {
            <p class="widget__error" data-testid="wcg-create-entity-error">{{ wizard.errorMessage() }}</p>
        }

        <div class="widget__actions">
            <button type="button" class="btn btn--secondary" [disabled]="wizard.submitting()" (click)="cancel()" data-testid="wcg-create-entity-cancel">Cancel</button>
            <button
                type="button"
                class="btn btn--primary"
                [disabled]="wizard.submitting() || wizard.activeTab() === 'investigator'"
                (click)="submit()"
                data-testid="wcg-create-entity-submit"
            >
                {{ wizard.submitting() ? 'Saving…' : 'Save' }}
            </button>
        </div>
    }

    @if (wizard.view() === 'success') {
        <div class="widget__success" data-testid="wcg-create-entity-success">
            <p class="widget__success-title">✓ Created</p>
            <ul class="widget__success-list">
                @let result = wizard.result();
                @switch (result?.kind) {
                    @case ('organization') {
                        <li>Organization: {{ result.data.organization_name }} ({{ result.data.organization_key }})</li>
                    }
                    @case ('facility') {
                        <li>Facility: {{ result.data.facility_name }} ({{ result.data.facility_key }})</li>
                    }
                    @case ('study') {
                        <li>Study: {{ result.data.study_name }} ({{ result.data.study_key }})</li>
                    }
                }
            </ul>
            <div class="widget__actions">
                <button type="button" class="btn btn--secondary" (click)="addAnother()" data-testid="wcg-create-entity-add-another">+ Add Another</button>
                <button type="button" class="btn btn--primary" (click)="done()" data-testid="wcg-create-entity-done">Done</button>
            </div>
        </div>
    }
</div>
